import { Controller } from "@hotwired/stimulus"

const KEYWORDS = {
  "Attunement": {
    title: "Attunement",
    description: "When this card is Drawn, activate Attunement effect"
  }
}

export default class extends Controller {
  connect() {
    this.tooltip = null
    this.element.querySelectorAll(".card-ref").forEach(span => {
      span.addEventListener("mouseenter", this.showCard.bind(this))
      span.addEventListener("mouseleave", this.hide.bind(this))
      span.addEventListener("mousemove", this.move.bind(this))
    })
  }

  disconnect() {
    this.hide()
  }

  show(e) {
    const keyword = e.target.dataset.keyword
    const def = KEYWORDS[keyword]
    if (!def) return

    this.tooltip = document.createElement("div")
    this.tooltip.className = "card-keyword-tooltip"
    this.tooltip.innerHTML = `
      <div class="card-keyword-tooltip-title">${def.title}</div>
      <div class="card-keyword-tooltip-desc">${def.description}</div>
    `
    document.body.appendChild(this.tooltip)
    this.position(e)
  }

  async showCard(e) {
    const cardName = e.target.dataset.cardName

    this.tooltip = document.createElement("div")
    this.tooltip.className = "card-keyword-tooltip"
    document.body.appendChild(this.tooltip)
    this.position(e)

    const res = await fetch(`/cards/lookup?name=${encodeURIComponent(cardName)}`)

    if (res.ok) {
      const html = await res.text()
      if (this.tooltip) {
        this.tooltip.innerHTML = html
      }
    } else {
      this.tooltip?.remove()
      this.tooltip = null
    }
  }

  hide() {
    this.tooltip?.remove()
    this.tooltip = null
  }

  move(e) {
    this.position(e)
  }

  position(e) {
    if (!this.tooltip) return
    this.tooltip.style.left = `${e.clientX + 12}px`
    this.tooltip.style.top = `${e.clientY + 12}px`
  }
}
